//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config';
import { pests } from '@/api/api_url';
import { getToken, formatYMD } from '@/libs/util';
import { renderFormMixins } from '@/mixins/renderFormMixins';
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import BmCityList from 'vue-baidu-map/components/controls/CityList.vue';
import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation.vue';
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue';
import BmLabel from 'vue-baidu-map/components/overlays/Label.vue';
import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue';
import { project_list } from '@/api/pests';
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      sampling_valueData: [{
        name: "5分钟",
        value: 300
      }, {
        name: "10分钟",
        value: 600
      }, {
        name: "15分钟",
        value: 900
      }, {
        name: "30分钟",
        value: 1800
      }, {
        name: "1小时",
        value: 3600
      }, {
        name: "2小时",
        value: 7200
      }, {
        name: "3小时",
        value: 10800
      }, {
        name: "5小时",
        value: 18000
      }, {
        name: "12小时",
        value: 43200
      }, {
        name: "24小时",
        value: 86400
      }],
      headers: {
        Authorization: getToken()
      },
      hasDisabled: true,
      formModel: {
        did: "",
        params_config_password: ""
      },
      formRules: {// sampling_value:[{required: true,type:"number", message: '采样频率不能为空', trigger: 'change'}
        //   ],
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {},
    projectCode: {}
  },
  components: {
    BaiduMap: BaiduMap,
    BmGeolocation: BmGeolocation,
    BmCityList: BmCityList,
    BmMarker: BmMarker,
    BmLabel: BmLabel,
    BmLocalSearch: BmLocalSearch
  },
  computed: {
    getAction: function getAction() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + pests.upload_file;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + pests.upload_file;
      } else {
        result = config.baseUrl.alp + "" + pests.upload_file;
      }

      return result;
    }
  },
  methods: {},
  mounted: function mounted() {
    //debugger
    if (this.edit) {
      if (this.setData) {
        console.log('a', this.setData); //alert()
        // Object.assign(this.formModel,this.setData)

        this.$set(this.formModel, 'did', this.setData.did);
        this.$set(this.formModel, 'params_config_password', this.setData.params_config_password); // console.log('b',this.formModel) 
      }
    }
  },
  created: function created() {//this.init()
  }
};